module.exports = __webpack_public_path__ + "img/Scorpius.1bea568b.png";